import React, { Component } from 'react';
import {Container, Button, Form} from 'semantic-ui-react'
import { translate } from 'react-i18next';
import API from '../utils/API'


class GiftCardsPane extends Component {

  constructor(props) {
    super(props)
    this.state = {
      code: '',
      fetching: false,
      errorMessage: null,
      success: false
    }
  }

  async redeem() {
    this.setState({fetching: true})
    try {
      const response = await API.useCoupon(this.state.code)
      if (response.ok) {
        this.setState({fetching: false, success: true, errorMessage: ''})
      } else {
        this.setState({fetching: false, errorMessage: response.data.message})
      }
    } catch (error) {
      this.setState({fetching: false, errorMessage: 'An error occured'})
    } 
    
  }


  render() {
    const { user, t } = this.props
    const { code, fetching, success, errorMessage } = this.state
    return (
          <div id="pdata-pane">
            <Container text>
            <div style={{position: 'relative', borderBottom: '1px solid black', marginBottom: '1rem'}}>
                  <h2 style={{textTransform: 'uppercase', marginBottom: '1rem'}}>{t('tabs:gifts')}</h2>
                </div>
              <p dangerouslySetInnerHTML={{__html: t('giftCards:noiTunes')}}></p>
              <p>{t('giftCards:enterCode')}</p>
              <Form>
                <Form.Field>
                    <Form.Input placeholder={'XXXX-XXXX-XXXX'} type="text" onChange={(e, data) => this.setState({code: data.value})} value={code} />
                </Form.Field>
              </Form>
              {errorMessage && errorMessage !== '' && <p style={{textAlign: 'center', marginTop: '1rem', color: '#ff6161'}}>
                {errorMessage}
              </p>}
              {success && <p style={{textAlign: 'center', marginTop: '1rem', color: '#16e816'}}>
              {t('giftCards:successMessage')}
              </p>}
              <p style={{textAlign: 'center', marginTop: '2rem'}}>
                <Button loading={fetching} icon style={{paddingLeft: '3rem', paddingRight: '3rem'}} disabled={code.length > 14 || code.indexOf('-') === -1 || success} onClick={() => this.redeem()}>{t('giftCards:redeem')}</Button>
              </p>
            </Container>
          </div>
    )
  }
}
 
export default translate('translations')(GiftCardsPane);


// WEBPACK FOOTER //
// ./src/components/GiftCardsPane.js